import ClientsGroupsXPlace from "./ClientsGroupsXPlace";

export default ClientsGroupsXPlace;
